/*global FB*/
// Copyright (c) 2015, Sony Global Education, Inc.
// All rights reserved.

import * as Constants from "./constants.js";
import $ from "jquery";

////////////////////////////////////////////////////////////
//
// Global variables.

export var G = {
  sectionStartDate: null,
  scoreResults: [0, 0, 0, 0, 0],
  resultType: -1,
  resultTitfle: "",
  resultDetail: "",
  resultImageSrc: "",
  resultImageAlt: "",
  resultTwitterText: "",
  facebookImageSrc: "",
};

////////////////////////////////////////////////////////////
//
// Move to new page.

export function moveToTop(e) {
  moveToMMindSite(e, Constants.MMIND_PATH);
}

export function moveToQuiz(e) {
  moveToMMindSite(e, Constants.QUIZ_PATH);
}

export function moveToFiveThinking(e) {
  moveToMMindSite(e, Constants.ABOUT_PATH);
}

export function moveToAsite(e) {
  moveToMMindSite(e, Constants.ASITE_PATH);
}

function moveToMMindSite(e, url) {
  e.preventDefault();
  window.location.href = url;
}

export function didClickDefaultTwitterButton(e) {
  postToTwitter(
    window.i18n.t(Constants.TWITTER_DEFAULT_TEXT),
    getLocalizedPRPageURL()
  );
}

export function didClickDefaultFacebookButton(e) {
  var l = window.i18n.language;

  // This URL might be relative on dev env, but on stg and
  // pro, this might be absolute URL.
  var p = Constants.FACEBOOK_DEFAULT_PICTURES[l];

  postToFacebook(p, window.i18n.t(Constants.FACEBOOK_DEFAULT_DESCRIPTION));
}

// ////////////////////////////////////////////////////////////
// //
// // Event Handlers.

function postToTwitter(text, url) {
  // Indigo comment
  // SiteAnalysis.send_event(
  //   GA_SEND_CATEGORY, GA_SEND_ACTION, GA_SEND_LABEL_TWITTER);

  var hashtag =
    window.i18n.language === "ja" ? "世界算数" : "globalmathchallenge";

  var href =
    "http://twitter.com/intent/tweet?button_hashtag=" +
    hashtag +
    "&text=" +
    encodeURIComponent(text) +
    "&lang=" +
    window.i18n.language +
    "&url=" +
    encodeURIComponent(url);
  return window.open(
    href,
    "tweetwindow",
    "width=550, height=450, personalbar=0, toolbar=0, scrollbars=1, resizable=!"
  );
}

function postToFacebook(picture, description) {
  // Indigo comment, skip SiteAnalysis
  // SiteAnalysis.send_event(
  //   GA_SEND_CATEGORY, GA_SEND_ACTION, GA_SEND_LABEL_FACEBOOK);

  if (typeof FB !== "undefined" && FB !== null) {
    return FB.ui(
      {
        method: "feed",
        link: getLocalizedPRPageURL(),
        picture: picture,
        name: window.i18n.t(Constants.FACEBOOK_NAME),
        description: description,
        caption: getLocalizedGMCTopPageURL(),
      },
      function (response) {
        if (response && !response.error_code) {
          console.log("Posting completed.");
          return;
        } else {
          console.log("Error while posting: " + response);
          console.log("Code: " + response.error_code);
          return;
        }
      }
    );
  } else {
    return window.open(
      "https://www.facebook.com/sharer/sharer.php?" +
        "u=" +
        encodeURIComponent(getLocalizedPRPageURL()),
      "facebook-share-dialog",
      "width=626,height=436"
    );
  }
}

export function setupFacebookSdk() {
  var l = window.i18n.language;
  if (l === "zh") {
    return;
  }

  window.fbAsyncInit = function () {
    var channelUrl;
    channelUrl = "//";
    channelUrl += window.location.hostname;
    if (window.location.port) {
      channelUrl += ":" + window.location.port;
    }
    channelUrl += "/channel.html";
    FB.init({
      appId: "3158435487543349",
      cookie: true,
      xfbml: true,
      version: "v8.0",
      channelUrl: channelUrl,
    });

    FB.AppEvents.logPageView();
  };

  (function (d, s, id) {
    var js,
      fjs = d.getElementsByTagName(s)[0];
    if (d.getElementById(id)) {
      return;
    }
    js = d.createElement(s);
    js.id = id;
    var fb_country = "ja_JP";
    if (window.i18n.language === "en") {
      fb_country = "en_US";
    } else if (window.i18n.language === "zh") {
      fb_country = "zh_CN";
    }
    js.src = "https://connect.facebook.net/" + fb_country + "/sdk.js";
    fjs.parentNode.insertBefore(js, fjs);
  })(document, "script", "facebook-jssdk");
}

// ////////////////////////////////////////////////////////////
// //
// // utils

export function calcCharacterType(results) {
  var r = 0;
  var v = -1;
  for (var i = 0, len = results.length; i < len; i++) {
    if (v < results[i]) {
      r = i;
      v = results[i];
    }
  }

  return r;
}

function getCurrentLocale() {
  return window.i18n.language;
}

function getLocalizedGMCTopPageURL() {
  var u = Constants.GMC_TOPPAGE_URL[getCurrentLocale()];
  return u;
}

function getLocalizedPRPageURL() {
  var u = Constants.PR_TOPPAGE_URL[getCurrentLocale()];
  return u;
}

function setupLineHeight() {
  var l = window.i18n.language;
  $(Constants.DYNAMIC_LINE_HEIGHT_CLASS_NAME).each(function () {
    if (l === "en") {
      $(this).addClass(Constants.LINE_HEIGHT_NARROW_CLASS_NAME);
    } else {
      $(this).removeClass(Constants.LINE_HEIGHT_NARROW_CLASS_NAME);
    }
  });
}

export function setupBasicPageComponents(a) {
  setupLineHeight();
}

// // EOF
